import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DeckScroller } from "@/components/DeckScroller";
import { DropCountdown } from "@/components/DropCountdown";
import { ProductCard } from "@/components/ProductCard";

export default function Home() {
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api.featured().then(setFeatured).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      {/* HERO */}
      <section className="max-w-6xl mx-auto px-5 pt-14 md:pt-20 relative">
        <img
          src="/assets/runrs-world.png"
          alt="RUNRS world graphic — letterman mascot leaning on an R in front of a globe"
          data-testid="hero-mascot"
          className="absolute top-0 right-4 w-[8.4rem] sm:w-[14.4rem] lg:w-[21.6rem] pointer-events-none select-none"
        />
        <p className="font-college text-lg text-red max-w-[62%] sm:max-w-none" data-testid="hero-kicker">FOR EVERYONE WHO MOVES</p>
        <h1 className="font-college text-[18vw] lg:text-[10.5rem] text-navy mt-2 leading-[0.95] tracking-tight" data-testid="hero-heading">
          RUNRS
        </h1>
        <p className="font-college text-2xl sm:text-3xl text-ink mt-3" data-testid="hero-slogan">
          PERSISTENCE &amp; LONGEVITY
        </p>
        <p className="text-base md:text-lg text-ink/70 mt-5 max-w-md leading-relaxed" data-testid="hero-copy">
          A community built on movement — walking, running, riding, skating.
          Movement over specified sport. Show up however you can.
        </p>
        <DropCountdown />
      </section>

      {/* THE DECK — full width, drag to flip through */}
      <section className="mt-10" data-testid="deck-section">
        <DeckScroller />
        <div className="max-w-6xl mx-auto px-5 flex flex-wrap items-center gap-4 mt-6 pb-16 md:pb-20">
          <Link
            to="/shop"
            data-testid="hero-shop-button"
            className="bg-navy text-paper font-college text-xl px-6 py-3 shadow-print hover:bg-red transition-colors"
          >
            SHOP THE PIECES
          </Link>
          <Link
            to="/show-up"
            data-testid="hero-showup-button"
            className="bg-paper text-ink font-college text-xl px-6 py-3 shadow-print hover:bg-yellow transition-colors"
          >
            SHOW UP
          </Link>
          <p className="font-college text-sm text-ink/50 ml-auto hidden md:block" data-testid="deck-hint">DRAG · CLICK ANY PAGE TO ENLARGE →</p>
        </div>
      </section>

      {/* FEATURED — controlled from the shop manager */}
      {featured.length > 0 && (
        <section className="max-w-6xl mx-auto px-5 pb-20" data-testid="featured-section">
          <h2 className="font-college text-3xl sm:text-4xl text-navy">FEATURED</h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8 mt-8">
            {featured.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
